import apiClient from "../config/apiClient";


export const fetchDoctors = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=utility/active-doctors`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
